import * as api from '../api/productAssociation.api';
import CustomFilters from '../types/CustomFilters';
import TreeNodeProps from '../types/TreeNodeProps';
import LookupCategories from '../types/LookupCategories';
import ProductSegmentLookup from '../types/ProductSegmentLookup';
import { ManufacturersDataItem } from '../api/productAssociation.api';

export const getLookupCategories = async (
  params: LookupCategories.Params
): Promise<LookupCategories.CategoryItem[]> => {
  const { sourceOwnerId, ...rest } = params;
  const { categories } = await api.getLookupCategories({ ...rest, sourceOwnerID: sourceOwnerId });
  return (categories ?? []).map(({ ID: id, name, hasChild }) => ({
    id: id,
    title: name,
    isLeaf: hasChild !== 'Y',
  }));
};

// TODO ask Dipanshu Ahuja about `customFilter`, `customFilterList` and `filterValues` if they can be `null`
export const getLookupCustomFilters = async (params: CustomFilters.Params): Promise<TreeNodeProps[]> => {
  const { customFilter } = await api.getLookupCustomFilters(params);
  const { customFilterList } = customFilter;
  return customFilterList.map(({ Id: id, filterLabel, filterValues }) => ({
    id: id,
    title: filterLabel,
    children: filterValues.map(({ label, value }) => ({
      id: [id, value].join('\n'),
      title: label,
    })),
  }));
};

export const getManufacturersByIds = async (manufacturerIds: string[]): Promise<ManufacturersDataItem[]> => {
  const { manufacturers } = await api.getManufacturersByIds({ manufacturerIds: manufacturerIds.join(',') });
  return manufacturers;
};

export const getProductSegmentLookup = async (productSegmentId: number): Promise<ProductSegmentLookup> => {
  const { productSegmentLookup } = await api.getProductSegmentLookup(productSegmentId);
  return productSegmentLookup;
};
